export class EvaSubscriptionDiscount {
  discount_id: string;
  start_dt: Date;
  end_dt: Date;
  name: string;
  title: string;
  subtitle: string;
  code: string;
  background: string;
  new_prices: any;

  public static createInstance(jsonData: any): EvaSubscriptionDiscount {
    const s = Object.assign(new EvaSubscriptionDiscount(), jsonData);
    if (s.start_dt) s.start_dt = new Date(s.start_dt);
    if (s.end_dt) s.end_dt = new Date(s.end_dt);
    return s;
  }

  public static createInstances(jsonData: any[]): EvaSubscriptionDiscount[] {
    return jsonData.map(EvaSubscriptionDiscount.createInstance);
  }

  getPrice(formulaName: string, interval: string) {
    if (!this.new_prices) return null;
    return this.new_prices[formulaName]?.[interval];
  }
}
